import React from 'react';
export const SkeletonParagraph = () => {
    return (
        <div>
            <p className="h-5 rounded w-5/6 my-2 bg-gray-400"></p>
            <p className="h-5 rounded w-11/12 my-2 bg-gray-400"></p>
            <p className="h-5 rounded w-6/8 my-2 bg-gray-400"></p>
        </div>
    )
}